import { api } from '../api';

const base = 'regime/mercadorias';
const RegimeMercadoriasService = {
  base,
  index: async (page = 1, limit = 20, sortColumn = null, sortOrder = null, filtros = {}) => {
    try {
      let url = `${base}/index?page=${page}&limit=${limit}`;

      if (sortColumn && sortOrder) {
        url += `&sortColumn=${sortColumn}&sortOrder=${sortOrder}`;
      }

      if (filtros) {
        Object.keys(filtros).forEach((campo) => {
          url += `&${campo}=${encodeURIComponent(filtros[campo])}`;
        });
      }

      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw new Error('Erro ao carregar a listagem de mercadorias.');
    }
  },
  view: async (id) => {
    try {
      const response = await api.get(`${base}/view/${id}`);
      return response.data;
    } catch (error) {
      throw new Error('Erro ao carregar a visualização da mercadoria.');
    }
  },
  historicoTributos: async (id, page = 1, limit = 20) => {
    try {
      const response = await api.get(`${base}/historicoTributos/${id}?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw new Error('Erro ao carregar o histórico dos tributos.');
    }
  },
};

export default RegimeMercadoriasService;
